import { AppThunk } from "appRedux/store"
import {
  initLogin,
  loginFailure,
  loginSuccess,
  logout,
  logoutSuccess,
  otpFailure,
} from "appRedux/reducers/userReducer"
// import { redirectTo } from "utils/links"
import { getItem, removeItem, setItem } from "services/localStorage.service"
// import AuthService from "services/auth.service"
import { redirectTo } from "utils/links"
import { AUTH_LOGIN_URL, AUTH_VERIFY_URL } from "utils/apiConfig"
import { setAuthorizationHeader } from "utils/auth"

import axios from "axios"

export const login =
  ({ email, password }: { email: string; password: string }): AppThunk =>
  async (dispatch) => {
    dispatch(initLogin())
    try {
      const emailNorm = email.trim()
      await axios.post(AUTH_LOGIN_URL, { email: emailNorm, password })
      setItem("email", emailNorm)
      // if(!response.data.success) {
      //     dispatch(loginFailure(response.data.message))
      // }
      // dispatch(loginSuccess(response.data))
      // setItem("x-auth-token", response.data.token)
      // window.location.reload()
      redirectTo("/verify")
    } catch (error: any) {
      dispatch(loginFailure(error.response.data.message))
    }
  }

export const verifyOtp =
  ({ code }: { code: string }): AppThunk =>
  async (dispatch) => {
    dispatch(initLogin())
    try {
      const response = await axios.post(AUTH_VERIFY_URL, {
        email: getItem("email") ?? "",
        otp: code,
        code,
      })
      // if (!response.data.success) {
      //   dispatch(loginFailure(response.data.message))
      // }
      dispatch(loginSuccess(response.data))
      setItem("x-auth-token", response.data.token)
      setItem("refreshToken", response.data.refreshToken)
      setAuthorizationHeader(response.data.token)
      redirectTo("/")
    } catch (error: any) {
      console.log("Herere", error)
      dispatch(otpFailure(error.response.data.message))
      // throw new Error("Verification code not found")
    }
  }

export const logOut = (): AppThunk => async (dispatch) => {
  try {
    dispatch(logout())
    // await logoutUser()
    dispatch(logoutSuccess())
    removeItem("x-auth-token")
    removeItem("refreshToken")
    removeItem("email")
    removeItem("persist:root")
    setAuthorizationHeader(null)
    redirectTo("/login")
  } catch (error) {}
}
